import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const MutedMarkPath = styled.path<{ $muted: boolean }>`
  opacity: ${({ $muted }) => ($muted ? 1 : 0)};
  translate: ${({ $muted }) => ($muted ? "0 0" : "-80% 0")};
  transition:
    0.2s opacity,
    0.3s translate;
`;

export const OuterWavePath = styled.path<{ $muted: boolean }>`
  opacity: ${({ $muted }) => ($muted ? 0 : 1)};
  translate: ${({ $muted }) => ($muted ? "-80% 0" : "0 0")};
  transform: ${({ $muted }) => ($muted ? "scale(0)" : "scale(1)")};
  transition:
    0.2s 0.08s opacity,
    0.3s 0.08s translate,
    0.4s 0.08s transform;
`;

export const InnerWavePath = styled.path<{ $muted: boolean }>`
  opacity: ${({ $muted }) => ($muted ? 0 : 1)};
  translate: ${({ $muted }) => ($muted ? "-80% 0" : "0 0")};
  transform: ${({ $muted }) => ($muted ? "scale(0)" : "scale(1)")};
  transition:
    0.2s opacity,
    0.3s translate,
    0.4s transform;
`;

export const MaskRect = styled.rect<{ $maskFill: string }>`
  fill: ${({ $maskFill }) => $maskFill};
`;

// DATA

// TYPES
export type Props = ComponentPropsWithRef<"svg"> & {
  /** Animates between the sound-wave glyph and the muted "x" mark. */
  $muted?: boolean;
  /** Fill for the rect masking the sound waves behind the cone — must be
   * opaque and match the surrounding surface, or the waves show through. */
  $maskFill?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
